import { IDriveViewTrashedFolder, IDriveViewTrashedPlacement } from '@commenda/types/src/drive-view/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export interface ITrashViewResponse {
  trashedPlacements: IDriveViewTrashedPlacement[];
  trashedFolders: IDriveViewTrashedFolder[];
  count: number;
}

export function useGetTrashView(corporationId: number | null) {
  const url = corporationId
    ? `drive-view/trash?corporationId=${corporationId}`
    : null;

  const {
    data,
    error,
    mutate,
  }: {
    data?: ITrashViewResponse;
    error?: unknown;
    mutate: KeyedMutator<ITrashViewResponse>;
  } = useSWR(url, SWRFetcher({ method: 'GET' }));

  return { data, error, mutate };
}
